module.exports = {
      id: "lulu-money-usage",
      viewBox: "0 0 398 134",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#lulu-money",
      toString: function () {
        return this.url;
      }
    }